import ToolTip from './ToolTip'

export default ToolTip
// eslint-disable-next-line import/export
export * from './ToolTip'
